import React from "react";
import { motion } from "framer-motion";

const TabNavigation = ({ activeTab, onTabChange, tabs }) => {
  return (
    <div
      className="flex rounded-xl p-1 gap-1 font-figtree overflow-x-auto"
      style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.08)" }}
    >
      {tabs.map((tab, index) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`relative flex-shrink-0 flex items-center justify-center transition-colors ${
            index === 0
              ? "min-w-[56px] h-[36px] px-2.5 py-2 rounded-lg font-medium"
              : "min-w-[92px] h-[36px] px-2.5 py-2 rounded-lg font-normal"
          } ${
            activeTab === tab.id ? "text-white" : "text-gray-400 hover:text-gray-200"
          }`}
        >
          {activeTab === tab.id && (
            <motion.div
              layoutId="activeTab"
              className="absolute inset-0 rounded-lg"
              style={{ background: "linear-gradient(135deg, #7c3aed, #6d28d9)" }}
              initial={false}
              transition={{ type: "spring", stiffness: 500, damping: 30 }}
            />
          )}
          <span className="relative flex items-center justify-center gap-1 whitespace-nowrap text-sm leading-5 text-center h-[20px]">
            {tab.label}
            <span
              className={`px-1.5 py-0.5 text-xs rounded-full font-medium ${
                activeTab === tab.id
                  ? "bg-white/20 text-white"
                  : "bg-white/10 text-gray-400"
              }`}
            >
              {tab.count}
            </span>
          </span>
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
